// extracted by mini-css-extract-plugin
module.exports = {"content":"BasicLayout_content__32je7","schoolContent":"BasicLayout_schoolContent__2d63Y"};